import Services from "assets/menu-icons/Services";
import projectConfig from "@/projectConfig";

const services = {
  id: 'services',
  type: 'group',
  visible: projectConfig.payment,
  children: [{
    id: 'services',
    title: 'Услуги', 
    type: 'item',
    url: '/services',
    icon: Services,
    breadcrumbs: false,
    visible: projectConfig.payment,
  }]
}

export default services;